// extracted by mini-css-extract-plugin
export default {"extendedPrompt":"FDdLAU","loginLink":"CrdS7P"};